module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "navs",
    staticClass: "view"
  }, [_c('div', {
    ref: "left",
    staticClass: "left blur"
  }), _vm._v(" "), _c('div', {
    ref: "right",
    staticClass: "right blur"
  }, [_c('div', {
    staticClass: "type"
  }, [_c('div', {
    staticClass: "comment"
  }, [_c('v-svg', {
    attrs: {
      "data": '#icon-liuyan'
    }
  })], 1), _vm._v(" "), (_vm.type) ? _c('div', {
    staticClass: "copy",
    on: {
      "click": _vm.copy
    }
  }, [_c('v-svg', {
    attrs: {
      "data": '#icon-shengcheng'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type) ? _c('div', {
    staticClass: "input"
  }, [_c('input', {
    ref: "Json",
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": JSON.stringify(_vm.novelty)
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.novelty), function(T1, K1) {
    return _c('div', {
      staticClass: "T1"
    }, [_c('h1', {
      staticClass: "pageT1"
    }, [_c('v-svg', {
      attrs: {
        "data": '#icon-' + T1.T1Name
      }
    }), _vm._v(_vm._s(T1.pageT1) + "\n      ")], 1), _vm._v(" "), _vm._l((T1.pageC1), function(T2, K2) {
      return _c('div', {
        staticClass: "T2"
      }, [_c('h2', {
        staticClass: "pageT2"
      }, [_c('v-svg', {
        attrs: {
          "data": '#icon-' + T2.T2Name
        }
      }), _vm._v(_vm._s(T2.pageT2) + "\n        ")], 1), _vm._v(" "), _c('div', {
        staticClass: "main"
      }, [_vm._l((T2.pageC2), function(List, K3) {
        return _c('v-list', {
          key: Number(List.Num),
          staticClass: "lists",
          style: ('order:' + T2.pageC2[K3].Num),
          attrs: {
            "New": List.New,
            "Name": List.Name,
            "Title": List.Title,
            "Img": List.Img,
            "Href": List.Href,
            "Num": Number(List.Num)
          },
          nativeOn: {
            "click": function($event) {
              _vm.onCopy(K1, K2, K3, List)
            }
          }
        })
      }), _vm._v(" "), (_vm.type) ? _c('div', {
        staticClass: "add",
        on: {
          "click": function($event) {
            _vm.addList(K1, K2, T2.pageC2)
          }
        }
      }, [_c('div', {
        staticClass: "list"
      }, [_c('v-svg', {
        attrs: {
          "data": '#icon-zengjia'
        }
      })], 1)]) : _vm._e()], 2)])
    })], 2)
  })], 2), _vm._v(" "), _c('com-copy', {
    attrs: {
      "New": _vm.Copy.New,
      "Name": _vm.Copy.Name,
      "Title": _vm.Copy.Title,
      "Img": _vm.Copy.Img,
      "Href": _vm.Copy.Href,
      "K1": _vm.Copy.K1,
      "K2": _vm.Copy.K2,
      "K3": _vm.Copy.K3,
      "Num": Number(_vm.Copy.Num)
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d939fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = 152
// module chunks = 1